import type { SVGProps } from 'react';

const SvgLogin = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M7.00043 2.00018H21.9994V22.0002H7.00043V18.0002H9.00043V20.0002H20.0004L20 3.99998L9.00043 4.00018V6.00018H7.00043V2.00018Z" />
    <path d="M13.5854 11L11.2934 8.70698L12.7074 7.29298L17.4144 12L12.7074 16.707L11.2934 15.293L13.5854 13H2.00043V11H13.5854Z" />
  </svg>
);
export default SvgLogin;
